import * as yup from 'yup'

import { trimmedInputValues, capitalizeWordsInValue } from '../utils';


const CompanyBankValidationSchema = yup.object().shape({
    bankName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter bank name')
        .transform((value) => trimmedInputValues(value)),
    holderName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter account holder name')
        .transform((value) => trimmedInputValues(value)),
    accNo: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter account number'),
        confirmAccountNo: yup.string()
        .oneOf([yup.ref('accNo'), null], 'Account no and confirm account no must match')
        .required('Please confirm your account number'),
    ifscCode: yup.string().when("isInternational", {
        is: true,
        then: () => yup.string().nullable(),
        otherwise: () =>  yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter ifsc code'),
    }),
    branchId: yup.array()
        .required('Please select branch'),
})


const companyBankInitialState = {
    bankName: '',
    holderName: '',
    accNo: '',
    confirmAccountNo: '',
    ifscCode: '',
    branchId: null,
    documentProof: '',
}


export { CompanyBankValidationSchema, companyBankInitialState }; 